import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirm-delete-modal',
    templateUrl: './confirm-delete-modal.component.html',
    styleUrls: ['./confirm-delete-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDeleteModalComponent implements OnInit, OnChanges {
  @Input() modalInstance = 1;
  @Input() showModal: boolean;
  @Input() hideModal: boolean;
  @Input() disableBtn: boolean;
  @Input() title: string;
  @Input() matchText: string;
  @Input() displayText: string;
  @Input() primaryAction: string;
  @Input() displayMessage?: string;
  @Input() hideInputconfirm?: boolean;
  @Input() type = 'danger';
  @Input() typeConfirmReq = true;
  @Output() confirmEvent = new EventEmitter();
  @Output() cancelConfirmEvent = new EventEmitter();
  confirmText = '';
  modalId = '';
  modalCloseId = '';

  constructor() { }

  get confirmed(): boolean {
    return this.normalizeConfirmText(this.confirmText) === 'confirm';
  }

  ngOnInit() {
    this.modalId = `deleteDeviceModel${this.modalInstance}`;
    this.modalCloseId = `closeModal${this.modalInstance}`;
  }

  ngOnChanges(changes) {
    this.modalId = `deleteDeviceModel${this.modalInstance}`;
    this.modalCloseId = `closeModal${this.modalInstance}`;
    // Show Modal
    if (changes.showModal && changes.showModal.previousValue !== undefined) {
      if (changes.showModal.previousValue !== changes.showModal.currentValue) {
        if (this.modalInstance === 1) {
          document.getElementById('deleteModal1').click();
        } else {
          document.getElementById('deleteModal2').click();
        }
        this.confirmText = '';
      }
    }
    // Hide Modal
    if (changes.hideModal && changes.hideModal.previousValue !== undefined) {
      if (changes.hideModal.previousValue !== changes.hideModal.currentValue) {
        document.getElementById(this.modalCloseId).click();
      }
    }
  }

  private normalizeConfirmText(value: string): string {
    return String(value || '')
      .trim()
      // Strip straight/curly quotes users may copy from the instruction text
      .replace(/^["'`\u201C\u201D\u2018\u2019]+|["'`\u201C\u201D\u2018\u2019]+$/g, '')
      .trim()
      .toLowerCase();
  }

  confirmDelete() {
    this.confirmEvent.emit();
  }
  cancelConfirm() {
    this.cancelConfirmEvent.emit();
  }
}
